export enum InstrTmplType {
    IN_OUT = "IN_OUT",
    REPORT = "REPORT",
    TASK = "TASK"
}

export default interface InstrTmpl {
    funId: number;
    name: string;
    tmplType: InstrTmplType;

    isInOut(): boolean;

    isReport(): boolean;

    isTask(): boolean;

    asInOut(): InOutInstrTmpl;

    asReport(): ReportInstrTmpl;

    asTask(): TaskInstrTmpl;
}

export abstract class BaseInstrTmpl implements InstrTmpl {
    funId!: number
    name!: string
    abstract tmplType: InstrTmplType

    isInOut(): boolean {
        return this.tmplType == InstrTmplType.IN_OUT
    }

    isReport(): boolean {
        return this.tmplType == InstrTmplType.REPORT
    }

    isTask(): boolean {
        return this.tmplType == InstrTmplType.TASK
    }

    asInOut(): InOutInstrTmpl {
        return this as unknown as InOutInstrTmpl
    }

    asReport(): ReportInstrTmpl {
        return this as unknown as ReportInstrTmpl
    }

    asTask(): TaskInstrTmpl {
        return this as unknown as TaskInstrTmpl
    }
}

export class InOutInstrTmpl extends BaseInstrTmpl {
    readonly tmplType = InstrTmplType.IN_OUT
    inputInstr!: string
    outputInstr!: string
}

export class ReportInstrTmpl extends BaseInstrTmpl {
    readonly tmplType = InstrTmplType.REPORT
    outputInstr!: string
}

export class TaskInstrTmpl extends BaseInstrTmpl {
    readonly tmplType = InstrTmplType.TASK
    inputInstr!: string
    publishInstr!: string
    publishedInstr!: string
    cancelInstr!: string
    canceledInstr!: string
    runInstr!: string
}
